var _a;
import { doFetch } from '../http-client';
import { getUserLocale } from '../i18n.service';
let dictionaryApiUrl = (((_a = window.glosbe) === null || _a === void 0 ? void 0 : _a.frontendApiUrl) || 'https://iapi.glosbe.com') + '/iapi3';
export function getOrDelete({ endpoint, params = {}, appendToken = false, options, url }) {
    let urlParams = params;
    Object.keys(urlParams).forEach(key => {
        if (urlParams[key] === undefined || urlParams[key] === null) {
            delete urlParams[key];
        }
    });
    if (!urlParams['env']) {
        urlParams['env'] = getUserLocale();
    }
    //options = this.setHeaders(options, headers);
    if (appendToken) {
        const timestampSeconds = Math.floor(new Date().getTime() / 1000);
        urlParams = Object.assign(Object.assign({}, urlParams), { timestamp: timestampSeconds });
    }
    const urlBuilder = [url ? url : dictionaryApiUrl, "/", endpoint];
    const paramsKeys = Object.keys(urlParams);
    if (paramsKeys.length > 0) {
        let query = paramsKeys
            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(urlParams[k]))
            .join('&');
        urlBuilder.push("?");
        urlBuilder.push(query);
    }
    return doFetch(urlBuilder.join(''), options);
}
export function post({ endpoint, data, formData, options }) {
    const requestOptions = Object.assign(Object.assign({}, options), { method: 'POST' });
    const existingHeaders = options && options.headers ? options.headers : {};
    if (formData) {
        requestOptions.headers = Object.assign({}, existingHeaders);
        requestOptions.body = formData;
    }
    else {
        requestOptions.body = JSON.stringify(data);
        requestOptions.headers = Object.assign(Object.assign({}, existingHeaders), { 'content-type': 'application/json' });
    }
    return doFetch(`${dictionaryApiUrl}/${endpoint}`, requestOptions);
}
